import { render, staticRenderFns } from "./FinanceBankDetailsContractors.vue?vue&type=template&id=3ca57a30&"
import script from "./FinanceBankDetailsContractors.vue?vue&type=script&lang=js&"
export * from "./FinanceBankDetailsContractors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports